export default __webpack_public_path__ + "static/media/JournalVoucher_Dark2.3880b33d.svg";